// extracted by mini-css-extract-plugin
export var logo = "_bn-2";
export var logoWrapper = "_bn-1";
export var strip = "_bn-0";